import alertHelper from "@/helper/AlertHelper";
import { mapGetters, mapMutations } from "vuex";
import Common from "../../common";

export const directBankMixin = {
  data() {
    return {
      carouselSlide: 0,
      selectedAmount: null,
      videoAddress: require("/src/assets/videos/payInstruction.mp4"),
      shetabAmounts: [],
      baseOptions: [],
      testOptions: [
        /*{value: 1100, text: '1,100  تومان'},
        {value: 1300, text: '1,300  تومان'},
        {value: 1500, text: '1,500  تومان'},
        {value: 1600, text: '1,600  تومان'},
        {value: 5000, text: '5,000  تومان'},
        {value: 6000, text: '6,000  تومان'},*/
      ],
      options: [],
      creditCardInfo: [
        { length: 4, value: "" },
        { length: 4, value: "" },
        { length: 4, value: "" },
        { length: 4, value: "" },
      ],
      pradoTempOptions: [
        { value: 100000, text: " 100,000 تومان" },
        { value: 200000, text: " 200,000 تومان" },
        { value: 500000, text: "500,000  تومان" },
        { value: 1000000, text: "1,000,000  تومان" },
        { value: 3000000, text: " 3,000,000 تومان" },
      ],
      selectedPaymentGate: "auto",
      mobileNumber: "",
      continuousCreditCardNumber: "",
      transactionId: "",
      mobileNumberValidation: false,
      localStorageData: [],
      savedCardNumbers: [],
      isLocalStorageEmpty: true,
      showSaveCard: true,
      filteredSavedCards: [],
      savedCardExpDate: [],
      doesItMatch: false,
      bankImageSource: "",
      checkIfInputNotEmpty: false,
      secondImportantAmounts: null, //this value type is always array
      fourthImportantAmounts: null, //but this one is string
      siteSettings: {},
      showVideo: false,
      secondContainerVisibility: false,
      tempSaderatBankDisabled: false,
      shetabNationalCodeModalVisibility: false,
    };
  },
  computed: {
    ...mapGetters([
      "getVersion",
      "getPayingAmount",
      "getCompleteCreditCardNumber",
      "getMobileNumber",
      "getGatewayPendingFlag",
      "isCreditCardReceivedFromServer",
      "isShetabAmountsReceivedFromServer",
      "isPhoneNumberReceivedFromServer",
      "getStepperPage",
      "getSitesApiResult",
      "getGlobalApiRequestPending",
      "getCallBackUrl",
      // "getSiteTheme",
    ]),
  },
  watch: {
    // get these apis when this condition changes
    // this condition indicate the previous api request is finished
    // this only runs on the second version
    // getGlobalApiRequestPending() {
    //   if (this.getSiteTheme === 2) {
    //     this.getShetabAmounts();
    //     this.getCashoutAmounts();
    //   }
    // },
    mobileNumber(value) {
      this.mobileNumberValidation =
        value.substring(0, 2) === "09" && value.length === 11;
    },
    creditCardInfo: {
      handler(val) {
        [this.checkIfInputNotEmpty, this.bankImageSource] =
          Common.checkWhatBank(this.creditCardInfo);
        const enteredCardNum =
          val[0].value + val[1].value + val[2].value + val[3].value;

        //checking credit card number validation
        if (enteredCardNum.length <= 16 && enteredCardNum.length > 0) {
          this.secondContainerVisibility =
            Common.validateCreditCardNumber(enteredCardNum);
        }

        this.setFilteredSavedCards(enteredCardNum);
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations([
      "setCompleteCreditCardNumber",
      "setMobileNumber",
      "setTransactionId",
      "setShetabSelectedPayingAmount",
      "setPaymentMethod",
      "setNationalCodeNeeded",
      "setSavedCardExpDate",
      "setIsCompName",
      "setStepperPage",
    ]),
    setFilteredSavedCards(cardNumber) {
      this.filteredSavedCards = [];
      for (let eachCard of this.savedCardNumbers) {
        if (eachCard.includes(cardNumber)) {
          this.filteredSavedCards.push(eachCard);
        } else {
          this.showSaveCard = false;
        }
      }
    },
    handleAutoFocus(index) {
      if (this.creditCardInfo[index].value.length === 4) {
        const nextIndex = index + 1;
        if (nextIndex < this.creditCardInfo.length) {
          const element = document.getElementById(
            `credit-card-input-key${nextIndex}`
          );
          if (element) {
            this.$nextTick(() => {
              element.focus();
            });
          }
          //  last input
        } else document.getElementById(`mobile-number-input`).focus();
      }
    },
    checkIfSaderatBank(cardNum) {
      const saderatBankCode = "603769";
      this.tempSaderatBankDisabled = cardNum === saderatBankCode;
    },
    onCreditCardPaste(evt, targetVariable) {
      Common.onInfoPaste.call(this, evt, targetVariable);
    },
    cancelPayment() {
      let paymentId = this.$route.query.id;
      alertHelper.loadingAlert();
      const callBackUrl = this.getCallBackUrl;
      if (callBackUrl) {
        window.location.href = Common.createCallback(callBackUrl, paymentId, 0);
      } else {
        this.$http.delete(`payments/${paymentId}`).then((result) => {
          window.location.href = Common.createCallback(
            result.data.data.callback_url,
            paymentId,
            0
          );
        });
      }
    },
    openVideoPlayer() {
      setTimeout(() => {
        this.showVideo = !this.showVideo;
      }, 50);
    },
    clickedOutSideOfVideo() {
      this.showVideo = !this.showVideo;
    },
    getShetabAmounts() {
      const siteResDataSettings = this.getSitesApiResult.data.settings;
      this.fourthImportantAmounts = siteResDataSettings.shetab_amounts;
      this.siteSettings = siteResDataSettings;

      //after finishing this set data,
      /** temporary disabled **/
      // this.showStartingAlert();

      this.setInputDataIfAvailable();
    },

    isCreditCardInputFilled() {
      for (let i = 0; i < this.creditCardInfo.length; i++) {
        if (this.creditCardInfo[i].value.length < 4) {
          return false; // At least one value doesn't meet the condition
        }
      }
      return true; // All values meet the condition
    },
    //this is the second important values, its after payments input
    getCashoutAmounts() {
      if (!this.$route.query.id) return;
      this.$http.get(`sites/cashout-amounts`).then(
        (result) => {
          this.secondImportantAmounts = result.body;
          this.setInputDataIfAvailable();
        },
        (error) => {
          console.log(error);
        }
      );
    },
    async handleSubmitNationalCode(nationalCode) {
      await this.submitInfo(true, nationalCode);
    },
    submitInfo(useNationalCode, nationalCode) {
      const paymentId = this.$route.query.id;
      const querySecret = this.$route.query.s;
      //secondContainerVisiblity indicates the validation of the user entered credit card number
      if (
        !this.isCreditCardInputFilled() ||
        !this.mobileNumberValidation ||
        !this.secondContainerVisibility ||
        (this.getVersion === "v1" ? this.selectedAmount == null : false)
      ) {
        alertHelper.errorAlert("", "لطفا تمامی فیلد هارا به درستی پر کنید");
      } else {
        if (this.tempSaderatBankDisabled) {
          alertHelper.errorAlert("", "بانک صادرات موقتا پشتیبانی نمیشود");
          return;
        }
        let from = "";
        for (let i = 0; i < this.creditCardInfo.length; i++) {
          from += this.creditCardInfo[i].value;
        }
        alertHelper.loadingAlert();
        let apiBody = {
          payment_id: paymentId,
          gateway: "SHETAB",
          amount: +this.selectedAmount,
          from: from,
          mobile: this.mobileNumber,
          method: this.selectedPaymentGate,
        };
        if (useNationalCode)
          apiBody = { ...apiBody, national_code: nationalCode };
        this.$http.post("transactions", apiBody).then(
          (result) => {
            if (result.status === 201) {
              this.setCompleteCreditCardNumber(from);
              this.setMobileNumber(this.mobileNumber);
              this.transactionId = result.data.data.id;
              this.setTransactionId(this.transactionId);
              this.setShetabSelectedPayingAmount(this.selectedAmount);
              this.setPaymentMethod(this.selectedPaymentGate);
              this.setNationalCodeNeeded(
                result.data.data.gateway_result
                  ? result.data.data.gateway_result.nationalCodeNeeded
                  : false
              );
              if (result.data.data.gateway_result.hasToken === true) {
                alertHelper.successAlert();
                this.$router.push(
                  `/shetab/payment-info?id=${paymentId}&s=${querySecret}`
                );
              } else {
                alertHelper.successAlert(
                  "",
                  "کد تایید به شماره موبایل شما ارسال شد",
                  1500
                );
                this.$router.push(
                  `/shetab/validation?id=${paymentId}&s=${querySecret}`
                );
              }
            }
          },
          (error) => {
            if (error.data.additional_info?.code === 3333) {
              // opens the national code Modal
              this.shetabNationalCodeModalVisibility = true;
              alertHelper.apiErrorAlert("", error.body.message);
            } else if (error.data.code === 2003) {
              alertHelper.apiErrorAlert("", error.body.message);
            } else if (error.status === 422) {
              alertHelper.apiErrorAlert(
                "",
                "اطلاعات وارد شده صحیح نمی باشد",
                10000,
                "تلاش مجدد"
              );
            } else {
              alertHelper.apiErrorAlert("", error.body.message);
            }
          }
        );
        for (let i = 0; i < this.creditCardInfo.length; i++) {
          this.$store.state.creditCardInfo[i] = this.creditCardInfo[i].value;
        }
      }
    },
    clickedOutSide() {
      this.showSaveCard = false;
    },
    onCreditCardInfoPaste(evt) {
      let clipboardData = evt.clipboardData.getData("text");
      //prevent auto focus
      if (clipboardData.length === 0) return;
      const result = clipboardData.match(/.{1,4}/g) ?? [];
      for (let index = 0; index < result.length; index++) {
        this.creditCardInfo[index].value = result[index];
      }
    },
    getLocalStorageData() {
      if (localStorage?.getItem("saveCardInfo") === "") {
        return;
      } else {
        this.showSaveCard = true;
        let savedCards = localStorage?.getItem("saveCardInfo")
          ? localStorage?.getItem("saveCardInfo").split("-")
          : [];
        let i = 0;
        for (let eachCardInfo of savedCards) {
          this.localStorageData[eachCardInfo] = JSON.parse(eachCardInfo);
          this.savedCardNumbers[i] =
            this.localStorageData[eachCardInfo]?.cardNumber;
          this.savedCardExpDate[i] =
            this.localStorageData[eachCardInfo]?.expDate;
          if (this.creditCardInfo[i]?.value === "") {
            this.filteredSavedCards[i] = this.savedCardNumbers[i];
          } else {
            break;
          }
          i = i + 1;
        }
      }
    },
    checkLocalStorage() {
      try {
        this.getLocalStorageData();
        this.isLocalStorageEmpty = localStorage?.getItem("saveCardInfo") === "";
      } catch (error) {
        this.isLocalStorageEmpty = true;
        console.warn("LocalStorage check failed:", error);
      }
    },
    // checkLocalStorage() {
    //   this.getLocalStorageData();
    //   this.isLocalStorageEmpty = localStorage?.getItem("saveCardInfo") === "";
    // },
    useThisCardInfoFromLocalStorage(cardInfo, index) {
      this.setSavedCardExpDate(this.savedCardExpDate[index]);
      for (let i = 0; i < this.creditCardInfo.length; i++) {
        let spiltedCardInfo = cardInfo.match(/.{1,4}/g);
        this.creditCardInfo[i].value = spiltedCardInfo[i];
        this.showSaveCard = false;
      }
    },
    useThisCardFromStore(cardInfo) {
      for (let i = 0; i < this.creditCardInfo.length; i++) {
        let splitedCardInfo = cardInfo.match(/.{1,4}/g);
        this.creditCardInfo[i].value = splitedCardInfo[i];
      }
    },
    /**
     * ##if data was available on the payment component, (from payment api important one)
     * importance level 1
     */
    setFirstImportantData() {
      //if string with multiple number splited by ","
      if (this.getPayingAmount && this.getPayingAmount?.split(",").length > 0) {
        this.options = Common.translateMultiNumberStringForSelector(
          this.getPayingAmount
        );
      }
      //if paying amount was available (only one value)
      if (this.getPayingAmount) {
        this.$nextTick(() => {
          this.selectedAmount = this.getPayingAmount;
        });
      }
      if (this.getCompleteCreditCardNumber) {
        this.useThisCardFromStore(this.getCompleteCreditCardNumber);
      }
      if (this.getMobileNumber) {
        this.mobileNumber = this.getMobileNumber;
      }
    },
    /**
     * ##if data was available on the cashout amount api
     * this is the second important data
     * importance level 2
     */
    setSecondImportantData() {
      //if data was available
      if (this.secondImportantAmounts) {
        if (this.secondImportantAmounts.length > 0) {
          this.options = Common.translateArrayForSelector(
            this.secondImportantAmounts
          );
        }
      }
    },
    /**
     * ##if the site api had cashout count value  > 0 then shetab_cashout_amounts is the value to set at a improtance level of three
     * importance level 3
     */
    setThirdImportantData() {
      //condition to set this data is that available_cashout value must be more than 0
      if (this.siteSettings) {
        if (
          this.siteSettings.available_cashouts > 0 &&
          this.siteSettings.shetab_cashout_amounts
        ) {
          this.options = Common.translateMultiNumberStringForSelector(
            this.siteSettings.shetab_cashout_amounts
          );
        }
      }
    },
    /**
     * basic data received from site api
     * ##this is the basic amounts, it will set value and not get overwritten when all of the other important data have no values
     * importance level 4
     */
    setFourthImportantData() {
      //because the format of the value is string of numbers
      if (this.fourthImportantAmounts) {
        if (this.fourthImportantAmounts.split(",").length > 0) {
          this.options = Common.translateMultiNumberStringForSelector(
            this.fourthImportantAmounts
          );
        }
      }
    },
    /**
     * this function will get executed by priority
     * when the less important data is set before the more important data, if the more important data is available,
     * it will get overwritten, else it will contain the less important data
     * this will get executed until it executes the most important data.
     */
    setInputDataIfAvailable() {
      this.setFourthImportantData();

      this.setThirdImportantData();

      this.setSecondImportantData();

      this.setFirstImportantData();
    },
    showStartingAlert() {
      let paymentId = this.$route.query.id;
      if (paymentId) {
        if (
          this.getVersion === "v1" &&
          //only if the route path was on the shetab page/ prevent unwanted alert open
          this.$route.path === "/"
        ) {
          alertHelper.shetabStartingAlert();
        }
      } else {
        alertHelper.transactionNotValidAlert();
      }
    },
    initApis() {
      // Call your API functions here
      this.$nextTick(() => {
        this.getShetabAmounts();
      });
      this.$nextTick(() => {
        this.getCashoutAmounts();
      });
    },
  },
  created() {
    this.setIsCompName("shetab");
    this.setStepperPage("pageOne");
    this.options = window.MODE
      ? window.MODE.toLowerCase() === "production"
        ? this.baseOptions
        : [...this.testOptions, ...this.baseOptions]
      : [...this.testOptions, ...this.baseOptions];
    if (window.location.host.includes("prdpayment")) {
      this.options = this.pradoTempOptions;
    }
  },

  mounted() {
    // we can also watch the value in the watch object, but then
    // we have to check the computed value of that value from the store
    // Check if the flag is initially false
    if (!this.getGlobalApiRequestPending) {
      this.initApis();
    } else {
      // Watch for changes to the flag
      this.$watch(
        () => this.getGlobalApiRequestPending,
        (newValue) => {
          if (!newValue) {
            // When the flag becomes false, call the APIs
            this.initApis();
          }
        }
      );
    }
  },
};
